import { DateTime } from 'luxon';
import MultiSort from 'multi-sort';

const getClosingDate = (business) => {
    if (!business) {
        return false;
    }

    if (!business.closingDate) {
        return false;
    }

    let result = false;

    const datas = business.closingDate;

    MultiSort(datas, {
        start: 'ASC',
    });

    //console.log(22222);
    //console.log(business.closingDate);

    datas.map((o) => {
        if (result === false) {
            if (o.display === 1) {
                result = o;
            } else {
                let start;
                let end;

                const now = DateTime.local().toMillis();

                if (+o.start_full_day === 1) {
                    start = DateTime.fromSQL(o.start).startOf('day').toMillis();
                } else {
                    start = DateTime.fromSQL(o.start).toMillis();
                }

                if (+o.end_full_day === 1) {
                    end = DateTime.fromSQL(o.end).endOf('day').toMillis();
                } else {
                    end = DateTime.fromSQL(o.end).toMillis();
                }

                //console.log(start);
                //console.log(now);
                //console.log(end);

                if (now < end) {
                    result = o;
                }
            }
        }
    });

    return result;
};

export default getClosingDate;
